import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from "rxjs";
import { Observable } from "rxjs/internal/Observable";
import { RelatorioCertidoes } from "../../model/relatorio-certidoes";
import { ArquivoBlobDTO } from "../../model/arquivoBlob.dto";
import { HttpClient, HttpParams } from "@angular/common/http";
import { GenericService } from "../../commons/generic.service";
import { environment } from "../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class RelatoriosSrhService extends GenericService {
  private path = environment.url + 'api/v1/';

  private tipoRelatorio:Subject<any> = new BehaviorSubject<any>([]);
  private tipoSubRelatorio:Subject<any> = new BehaviorSubject<any>([]);

  constructor(http: HttpClient) {
    super(http);
  }
  get tipoRelatorio$(){
    return this.tipoRelatorio.asObservable();
  }

  addTipoRelatorio(data:Node) {
    this.tipoRelatorio.next(data);
  }

  get tipoSubRelatorio$(){
    return this.tipoSubRelatorio.asObservable();
  }

  addTipoSubRelatorio(data:Node) {
    this.tipoSubRelatorio.next(data);
  }

  getListaTiposRelatorios(urlTipoRelatorio): Observable<RelatorioCertidoes[]> {
    return this.http.get<RelatorioCertidoes[]>(`${this.path}${urlTipoRelatorio}`);
  }

  getRelatorios(params: HttpParams, urlTipoRelatorio): Observable<ArquivoBlobDTO> {
    return this.http.get<ArquivoBlobDTO>(`${this.path}${urlTipoRelatorio}`, {params, responseType: 'blob' as 'json'});
  }
}
